<template>
  <div class="handlePlace">
    <span class="title">办理地点和时间</span>
    <div class="placeWrap" v-if="selectType === 'manual'">
      <div class="placeLi">
        <div class="mainLi">
          <span class="icon">
            <img src="../place.png" class="iconStyleplace" alt=""/>
          </span>
          <span class="content">{{ taskPlace }}</span>
        </div>
        <div class="mainLi">
          <span class="icon">
            <img src="../placetime.png" class="iconStyletime" alt=""/>
          </span>
          <span class="content">{{ taskHandleTime }}
          </span>
        </div>
      </div>
    </div>
    <div class="placeWrap-map" v-else>
      <div class="placeLi">
        <div>
          <img src="../map.svg" alt="地图" style="cursor:pointer;width: 298px" @click="toMapDetails">
        </div>
        <div class="mainLi" style="margin-top:17px">
          <span class="icon">
            <img src="../place.png" class="iconStyleplace" alt=""/>
          </span>
          <span class="content">{{ taskPlace }}</span>
        </div>
        <div class="mainLi" style="margin-bottom: -20px;">
          <span class="icon">
            <img src="../placetime.png" class="iconStyletime" alt=""/>
          </span>
          <span class="content">{{ taskHandleTime }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import locationIcon from '@/assets/jiopweb3.0.0/locationIcon.svg?inline'
import clockIcon from '@/assets/jiopweb3.0.0/clock.svg?inline'

export default {
  props: {
    mapData: {
      type: String,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: ''
    },
    taskPlace: {
      type: String,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: ''
    },
    taskHandleTime: {
      type: String,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: ''
    },
    selectType: {
      type: String,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: 'manual'
    },
    placeId: {
      type: String,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: ''
    }
  },
  data () {
    return {
      clockIcon,
      locationIcon
    }
  },
  created () {

  },
  methods: {
    toMapDetails () {
      if (this.selectType === 'jmap' && this.mapData !== null) {
        const url = JSON.parse(this.mapData).jmapUrl
        window.open(url, '_blank')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.handlePlace {
  .title {
    font-size: 22px;
    color: #333333;
    font-weight: 500;
  }
  .placeWrap-map{
    margin-top:10px;
    padding: 30px;
    border: 1px solid rgba(238, 238, 238, 1);
    .placeLi {
      border-top: 1px solid rgba(238, 238, 238, 1);
      // padding-top: 10px;
      .mainLi {
        display: flex;
        align-items: flex-start;
        line-height: 30px;
        .icon {
          font-size: 16px;
          margin-right: 12px;
        }
        .content {
          margin-bottom: 10px;
        }
      }
    }
    .placeLi:first-child {
      border: none;
    }
  }
  .placeWrap {
    margin-top:10px;
    padding: 30px;
    height: 343px;
    overflow-y: auto;
    padding-top: 10px;
    border: 1px solid rgba(238, 238, 238, 1);
    .placeLi {
      border-top: 1px solid rgba(238, 238, 238, 1);
      padding-top: 10px;
      .mainLi {
        display: flex;
        align-items: flex-start;
        line-height: 30px;
        .icon {
          width: 30px;
          font-size: 16px;
          margin-right: 12px;
        }
        .content {
          margin-bottom: 10px;
        }
      }
    }
    .placeLi:first-child {
      border: none;
    }
  }
  .iconStyleplace {
        width: 18px;
        // height: 14px;
        margin-top: -3px;
        margin-right: -2px;
  }
  .iconStyletime {
        width: 18px;
        // height: 14px;
        margin-right: -4px;
        margin-top: -3px;
  }
}
</style>
